// AboutUs.jsx - Ceylon Wayfinder Premium Taxi Service
import React, { useEffect } from 'react';
import './aboutus.css';

const AboutUs = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="aboutus-container">

      {/* Floating Particles - Subtle */}
      <div className="aboutus-particles">
        {[...Array(30)].map((_, i) => (
          <div
            key={i}
            className="particle"
            style={{
              left: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 15}s`,
              animationDuration: `${15 + Math.random() * 10}s`,
              width: `${2 + Math.random() * 6}px`,
              height: `${2 + Math.random() * 6}px`,
              background: `rgba(180, 211, 48, ${0.1 + Math.random() * 0.15})`,
            }}
          />
        ))}
      </div>

      {/* Hero Section */}
      <div className="aboutus-hero">
        <img 
          src="/bannerceylonwayfinder.png" 
          alt="Ceylon Wayfinder Premium Taxi Service" 
          className="aboutus-hero-image"
        />
        <div className="aboutus-hero-overlay"></div>
        
        <div className="aboutus-hero-content">
          <div className="aboutus-hero-subtitle">ABOUT</div>
          <h1 className="aboutus-hero-title">
            CEYLON <span>WAYFINDER</span>
          </h1>
          <p className="aboutus-hero-description">
            Premium, trustworthy & reliable taxi services across Sri Lanka. 
            Your safety and comfort are our highest priority.
          </p>
        </div>
        
        <div className="aboutus-scroll-indicator">
          <span>Discover More</span>
          <div className="mouse">
            <div className="mouse-wheel"></div>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="aboutus-content">
        
        {/* Introduction Section */}
        <div className="aboutus-intro">
          <div className="aboutus-intro-content">
            <span className="aboutus-intro-tag">Our Story</span>
            <h2 className="aboutus-intro-title">
              Your Trusted <span>Travel Partner</span> in Sri Lanka
            </h2>
            <p className="aboutus-intro-text">
              Founded in 2021, Ceylon Wayfinder has grown to become one of Sri Lanka's most 
              trusted premium taxi services. We understand that reliable transportation is 
              essential for both travelers and locals alike. Our commitment to excellence, 
              safety, and customer satisfaction sets us apart in the industry.
            </p>
            
            <div className="aboutus-intro-features">
              <div className="aboutus-feature">
                <span>Fully Licensed & Insured</span>
              </div>
              <div className="aboutus-feature">
                <i className="fas fa-leaf">🌿</i>
                <span>Eco-Friendly Fleet</span>
              </div>
              <div className="aboutus-feature">
           
                <span>24/7 Availability</span>
              </div>
              <div className="aboutus-feature">
       
                <span>Premium Service</span>
              </div>
            </div>
          </div>
          
          <div className="aboutus-intro-image">
            <img 
              src="/ceylon wayfinder.png" 
              alt="Ceylon Wayfinder Premium Fleet" 
            />
          </div>
        </div>

        {/* Stats Section */}
        <div className="aboutus-stats">
          <div className="aboutus-stat-item">
            <div className="aboutus-stat-number">5+</div>
            <div className="aboutus-stat-label">Years of Excellence</div>
          </div>
          <div className="aboutus-stat-item">
            <div className="aboutus-stat-number">10+</div>
            <div className="aboutus-stat-label">Vehicles</div>
          </div>
          <div className="aboutus-stat-item">
            <div className="aboutus-stat-number">4k+</div>
            <div className="aboutus-stat-label">Happy Customers</div>
          </div>
          <div className="aboutus-stat-item">
            <div className="aboutus-stat-number">24/7</div>
            <div className="aboutus-stat-label">Customer Support</div>
          </div>
        </div>

        {/* Mission & Vision */}
        <div className="aboutus-mission">
          <div className="aboutus-mission-card">
            <div className="aboutus-mission-icon">
              <img src="/mission.png" alt="Mission" />
            </div>
            <h3 className="aboutus-mission-title">Our Mission</h3>
            <p className="aboutus-mission-text">
              To provide exceptional, reliable, and safe transportation services that exceed 
              customer expectations. We are committed to:
            </p>
            <ul className="aboutus-mission-list">
              <li><i className="fas fa-check-circle">✓</i> Punctuality & Reliability</li>
              <li><i className="fas fa-check-circle">✓</i> Professional, Trained Drivers</li>
              <li><i className="fas fa-check-circle">✓</i> Clean, Well-Maintained Vehicles</li>
              <li><i className="fas fa-check-circle">✓</i> Transparent Pricing</li>
            </ul>
          </div>

          <div className="aboutus-mission-card">
            <div className="aboutus-mission-icon">
              <img src="/vision.png" alt="Vision" />
            </div>
            <h3 className="aboutus-mission-title">Our Vision</h3>
            <p className="aboutus-mission-text">
              To become Sri Lanka's most trusted and preferred premium taxi service, known for:
            </p>
            <ul className="aboutus-mission-list">
              <li><i className="fas fa-check-circle">✓</i> Uncompromising Safety Standards</li>
              <li><i className="fas fa-check-circle">✓</i> Exceptional Customer Experience</li>
              <li><i className="fas fa-check-circle">✓</i> Modern, Eco-Friendly Fleet</li>
              <li><i className="fas fa-check-circle">✓</i> Innovative Technology Integration</li>
            </ul>
          </div>
        </div>

        {/* Core Values */}
        <div className="aboutus-values">
          <h2 className="aboutus-section-title">Our Core Values</h2>
          <p className="aboutus-section-subtitle">
            The principles that guide every journey with Ceylon Wayfinder
          </p>
          
          <div className="aboutus-values-grid">
            <div className="aboutus-value-item">
              <div className="aboutus-value-icon">
                <img src="/trust.png" alt="Trust" />
              </div>
              <h3 className="aboutus-value-title">Trust</h3>
              <p className="aboutus-value-description">
                We build lasting relationships through honest, transparent, and reliable service. 
                Your trust is our greatest asset.
              </p>
            </div>

            <div className="aboutus-value-item">
              <div className="aboutus-value-icon">
                <img src="/safety.png" alt="Safety" />
              </div>
              <h3 className="aboutus-value-title">Safety</h3>
              <p className="aboutus-value-description">
                Your safety is our top priority. Regular vehicle maintenance, trained drivers, 
                and 24/7 monitoring ensure peace of mind.
              </p>
            </div>

            <div className="aboutus-value-item">
              <div className="aboutus-value-icon">
                <img src="/excellence.png" alt="Excellence" />
              </div>
              <h3 className="aboutus-value-title">Excellence</h3>
              <p className="aboutus-value-description">
                We strive for excellence in every aspect of our service, from first contact 
                to final destination.
              </p>
            </div>
          </div>
        </div>

        {/* Why Choose Us Section */}
        <div className="aboutus-why">
          <h2 className="aboutus-section-title">Why Choose Ceylon Wayfinder?</h2>
          <p className="aboutus-section-subtitle">
            Experience the difference with Sri Lanka's premium taxi service
          </p>

          <div className="aboutus-why-grid">
            <div className="aboutus-why-item">
           
              <h3>Modern Vehicles</h3>
              <p>Well-maintained, air-conditioned vehicles for your comfort and safety</p>
            </div>
            <div className="aboutus-why-item">
           
              <h3>Professional Drivers</h3>
              <p>Experienced, licensed, and background-checked drivers</p>
            </div>
            <div className="aboutus-why-item">
           
              <h3>GPS Tracking</h3>
              <p>Real-time vehicle tracking for enhanced security</p>
            </div>
            <div className="aboutus-why-item">
              <h3>Easy Payment</h3>
              <p>Multiple payment options</p>
            </div>
          </div>
        </div>

        {/* CTA Section */}
        <div className="aboutus-cta">
          <h2 className="aboutus-cta-title">Ready to Experience Premium Travel?</h2>
          <p className="aboutus-cta-text">
            Book your ride with Ceylon Wayfinder today and discover the difference 
            of professional, reliable transportation across Sri Lanka.
          </p>
          <a href="/booking" className="aboutus-cta-button">
            Book Your Ride Now
          </a>
        </div>
      </div>
    </div>
  );
};

export default AboutUs;